import { useEffect } from "react"

export default function TermsOfService() {
  useEffect(() => {
    window.location.href = "https://www.getvibrato.com/c/terms-of-service"
  }, [])

  return (
    <div className="w-full p-8 flex items-center justify-center">
      <p className="text-lg">Redirecting to Terms of Service...</p>
    </div>
  )
}
